/**
 * 药品短缺项目接口配置
 *
 */
const setCookie = require('./cookie').setCookie;
;
(function (window, $, undefined) {
  // 取得工程目录
  var localObj = window.location;
  var hasSubDomain = false;
  // 是否只有主域名
  var isRootDomain = true;
  var paths = localObj.pathname.split("/");
  var path = "";
  if (paths.length >= 3) {
    path = localObj.pathname.split("/")[1];
    if (paths[3]) {
      hasSubDomain = true;
    }
    if (path) {
      isRootDomain = false;
    }
  }

  var rootDomain = localObj.protocol + "//" + localObj.host;


  var pathHref = "";
  var pathHref1 = "";
  var str = "";
  // console.log(process.env.BUILD_FLAG)
  if (process.env.BUILD_FLAG === 'devBuild') {//本地部署环境
    pathHref = 'http://192.168.20.182:1105';
    pathHref1 = "http://192.168.20.182:1105/report/w";
    str = "/security/login";
    setCookie('isTest', false)
    // window.isTest = false;
  } else if (process.env.BUILD_FLAG === 'test') {//测试部署环境
    pathHref = 'http://192.168.20.6:1080';
    pathHref1 = "http://192.168.20.6:1080/report/w";
    pathHref = rootDomain;
    pathHref1 = rootDomain + "/report/w";
    str = "/security/login";
    setCookie('isTest', 'test')
    // window.isTest = true;
  } else if (process.env.BUILD_FLAG === 'online') {//线上部署环境
    pathHref = rootDomain;
    pathHref1 = rootDomain + "/report/w";
    str = "/security/login";
    setCookie('isTest', false)
    // window.isTest = false;
  } else {//本地环境
    // pathHref = 'http://192.168.101.93:6785';
    // pathHref1 = "http://192.168.101.93:6785/report/w";
    // pathHref = 'http://192.168.20.182:6706';
    // pathHref1 = "http://192.168.101.182:6706/report/w";
    // pathHref = "http://192.168.101.93:6705"

    //pathHref = 'http://124.127.208.37:1080';
    pathHref = 'http://192.168.20.6:1080';
    pathHref = '/myapi';
    //pathHref1 = "http://124.127.208.37:1080/report/w";
    pathHref1 = "http://192.168.20.6:1080/report/w";
    pathHref1='/mykk';
    str = "/security/login";
    setCookie('isTest', false)
    // window.isTest = false;
    // pathHref = 'http://192.168.20.25:1105';
    // pathHref1 = "http://192.168.20.25:1105/report/w"; 
  };

  // 接口调用
  var Action = {
    'DONPATH': pathHref + '/admin/static/',
    // 文件上传
    'ADMIN_UPLOAD_FILE': pathHref + '/admin/w/upload/uploadProvFile',//省级文件上传
    'ADMIN_UPLOAD_UPLOADFILE': pathHref + '/admin/w/uploadFile',//文件上传
    'ADMIN_UPLOADIMG': pathHref + '/admin/w/uploadImg',//图片上传

    // 登录相关接口

    'ADMIN_AREAMEDINST_LISTBYAREA': pathHref + '/admin/w/areaMedInst/listByArea',//已激活管理部门账号登录获取机构列表
    // 已短缺药品确认
    'ADMIN_SUBURBAN_COLLECT': pathHref + '/admin/w/suburban/suburbanCollect',//县级列表
    'ADMIN_SUBURBAN_SUBURBANCOLLECTSECOND': pathHref + '/admin/w/suburban/suburbanCollectSecond',//县级列表
    'ADMIN_SUBURBAN_SUBMIT': pathHref + '/admin/w/suburban/submit',//县级提交
    'ADMIN_URBAN_COLLECT': pathHref + '/admin/w/urban/urbanCollect',//市级列表 
    'ADMIN_URBAN_SUBMIT': pathHref + '/admin/w/urban/submit',//市级提交
    'ADMIN_PVOVINCE_COLLECT': pathHref + '/admin/w/province/provinceCollect',//省级列表
    'PROVINCE_CIRPROVINCECOLLECT': pathHref + '/admin/w/province/cirProvinceCollect',//省级列表
    'ADMIN_PVOVINCE_SUBMIT': pathHref + '/admin/w/province/submit',//省级提交
    'ADMIN_PVOVINCE_CIRSUBMIT': pathHref + '/admin/w/province/cirSubmit',//省级提交
    'ADMIN_COUNTRYSTATIS_COUNTRYDRUGCOLLECT': pathHref + '/admin/w/countryStatis/countryDrugCollect',//国家列表
    'ADMIN_COUNTRYSTATIS_COUNTRYTODEALSHORTDRUG': pathHref + '/admin/w/countryStatis/countryToDealShortDrug',//国家处置

    // 国家基础信息相关接口
    'ADMIN_BASICDEPT_PROVLIST': pathHref + '/admin/w/basicDept/provList',//管理机构列表省级
    'ADMIN_BASICDEPT_LIST': pathHref + '/admin/w/basicDept/list',//管理机构列表国家
    'ADMIN_BASICDEPT_OPENORCLOSE': pathHref + '/admin/w/basicDept/openOrClose',//开启/关闭账户状态
    'ADMIN_BASICDEPT_DELETE': pathHref + '/admin/w/basicDept/delete',//删除管理机构账户
    'ADMIN_BASICDEPT_GETMANAGERUSER': pathHref + '/admin/w/basicDept/getManagerUser',//获取当前账户信息
    'ADMIN_BASICDEPT_IMPORT': pathHref + '/admin/w/basicDept/import',//导入用户信息
    'ADMIN_BASICDEPT_EXPORT': pathHref + '/admin/w/basicDept/export',//导出用户信息
    'ADMIN_BASICMEDICAL_LIST': pathHref + '/admin/w/basicMedical/list',//医疗机构列表
    'ADMIN_BASICMEDICAL_ADD': pathHref + '/admin/w/basicMedical/add',//医疗机构新增
    'ADMIN_BASICMEDICAL_OPENORCLOSE': pathHref + '/admin/w/basicMedical/openOrClose',//开启/关闭医疗机构账户状态
    'ADMIN_BASICMEDICAL_DELETE': pathHref + '/admin/w/basicMedical/delete',//删除医疗机构账户
    'ADMIN_BASICMEDICAL_GET': pathHref + '/admin/w/basicMedical/get',//获取机构当前账户信息
    'ADMIN_BASICMEDICAL_EDIT': pathHref + '/admin/w/basicMedical/edit',//修改当前用户信息
    'ADMIN_BASICMEDICAL_IMPORT': pathHref + '/admin/w/basicMedical/import',//导入用户信息
    // 'ADMIN_BASICMEDICAL_EXPORT':pathHref+'/admin/w/basicMedical/export',//导出用户信息
    'ADMIN_BASICDEPT_EXPORTPROV': pathHref + '/admin/w/basicDept/exportProv',//省级导出用户信息
    'ADMIN_BASICDRUG_LIST': pathHref + '/admin/w/basicDrug/list',//药品数据字典列表
    'ADMIN_BASICDRUG_ADD': pathHref + '/admin/w/basicDrug/add',//药品数据字典新增
    'ADMIN_BASICDRUG_GET': pathHref + '/admin/w/basicDrug/get',//药品数据字典查询
    'ADMIN_BASICDRUG_EDIT': pathHref + '/admin/w/basicDrug/edit',//药品数据字典编辑
    'ADMIN_BASICDRUG_DELETE': pathHref + '/admin/w/basicDrug/delete',//药品数据字典删除
    'ADMIN_BASICDRUG_IMPORT': pathHref + '/admin/w/basicDrug/import',//导入药品信息
    'ADMIN_COMPANYDATA_LIST': pathHref + '/admin/w/companyData/list',//企业信息管理列表
    'ADMIN_COMPANYDATA_ADD': pathHref + '/admin/w/companyData/add',//企业信息管理新增
    'ADMIN_COMPANYDATA_GET': pathHref + '/admin/w/companyData/get',//企业信息管理查询
    'ADMIN_COMPANYDATA_EDIT': pathHref + '/admin/w/companyData/edit',//企业信息管理编辑
    'ADMIN_COMPANYDATA_DELETE': pathHref + '/admin/w/companyData/delete',//企业信息管理删除
    'ADMIN_COMPANYDATA_IMPORT': pathHref + '/admin/w/companyData/import',//导入企业用户信息
    'ADMIN_COMPANYDATA_EXPORT': pathHref + '/admin/w/companyData/export',//导出企业用户信息
    'ADMIN_COMPANYDATA_SELECTDURGDICTINFO': pathHref + '/admin/w/drugList/selectDurgDictInfo',//根据药品名称查询所有信息
    'REPORTDRUG_DRUGNAMEACLISTCON': pathHref1 + '/reportDrug/drugNameAcListCon',//查药品

    'ADMIN_BASICMEDICAL_EXPORT': pathHref + '/admin/w/basicMedical/export',//导出1--打包
    'ADMIN_BASICMEDICAL_REALTIME': pathHref + '/admin/w/basicMedical/realtime',//导出1--监听打包状态
    'ADMIN_BASICMEDICAL_DOWNLOADFILE': pathHref + '/admin/w/basicMedical/downloadFile',//导出1--下载文件
    'BASICMEDICAL_DOWNLOAD': pathHref + '/admin/w/basicMedical/download/',//导出1--下载文件
    
    //国家(省级)短缺药品的接口
    DRUGLIST_LIST: pathHref + '/admin/w/drugList/list',//短缺药品的清单（进入页面就获取显示的数据）
    JC_DRUGLIST_LIST: pathHref + '/admin/w/drugList/jcDrugList',//集采药品的清单（进入页面就获取显示的数据）
    DRUGLIST_ADD: pathHref + '/admin/w/drugList/add',//添加国家短缺药品
    DRUGLIST_EDIT: pathHref + '/admin/w/drugList/edit',//编辑国家短缺药品
    DRUGLIST_DELETE: pathHref + '/admin/w/drugList/delete',//删除国家短缺药品
    DRUGLIST_PEOVLIST: pathHref + '/admin/w/drugList/provList',//省级短缺药品
    SUBURBAN_STATISTIC: pathHref + '/admin/w/suburban/statistic',//统计分析 县级短缺药品上报
    SUBURBAN_CIRSTATISTIC: pathHref + '/admin/w/suburban/cirStatistic',//统计分析 县级短缺药品上报
    SUBURBAN_HOSPITALLEVEL: pathHref + '/admin/w/suburban/hospitalLevel',//县级短缺药品上报查看详情
    SUBURBAN_CIRHOSPITALLEVEL: pathHref + '/admin/w/suburban/cirHospitalLevel',//县级短缺药品上报查看详情
    SUBURBAN_FUZZY: pathHref + '/admin/w/suburban/fuzzy',//根据输入的部分药品名称，查询药品的全名
    SUBURBAN_SUBURBANSTOCK: pathHref + '/admin/w/suburban/suburbanStock',//点击查询结果返回的数据（县级）
    URBAN_URBANDRUGSTOCK: pathHref + '/admin/w/urban/urbanDrugStock',//点击查询结果返回的数据（市级）

    DRUGLIST_PUBLISH: pathHref + '/admin/w/drugList/publish',//发布国家短缺药品
    DRUGLIST_PROVLIST: pathHref + '/admin/w/drugList/provList',//省级短缺药品清单


    // 县级
    SUBURBAN_BRANCH: pathHref + '/admin/w/suburban/branch',//根据药品去查询各个医院该药品的库存量
    URBAN_SUBURBANSTOCK: pathHref + '/admin/w/urban/suburbanStock',//查询市级各个辖区内的存储分布
    SUBURBAN_BRANCHEXPORT: pathHref + '/admin/w/suburban/branchExport',//清单内库存统计导出
    // SUBURBAN_STATISTICEXPORT: pathHref + '/admin/w/suburban/statisticExport', //县导出所有数据
    SUBURBAN_STATISTICEXPORT: pathHref + '/admin/w/suburban/statisticExportT', //县导出所有数据


    // 市级
    URBAN_URBANSTOCK: pathHref + '/admin/w/urban/urbanStock',//根据药品去查询各个医院该药品的库存量
    URBAN_STATISTIC: pathHref + '/admin/w/urban/statistic',//根据药品去查询各个医院该药品的库存量
    URBAN_URBANSTOCKEXPORT: pathHref + '/admin/w/urban/urbanStockExport',//清单内库存统计导出
    // URBAN_STATISTICEXPORT: pathHref + '/admin/w/urban/statisticExport', //市导出所有数据
    URBAN_STATISTICEXPORT: pathHref + '/admin/w/urban/statisticExportT', //市导出所有数据

    // 省级
    PROVINCE_STATISTIC: pathHref + '/admin/w/province/statistic',//省级用户页面加载时，对省级以下所有医疗机构填报信息进行统计
    PROVINCE_OTHER: pathHref + '/admin/w/province/other',//其他省短缺情况
    PROVINCE_PROVINCESTOCK: pathHref + '/admin/w/province/provinceStock',//搜索药品
    PROVINCE_STOCK: pathHref + '/admin/w/province/stock',//省查市短缺
    // PROVINCE_STATISTICEXPORT: pathHref + '/admin/w/province/statisticExport',//导出
    PROVINCE_STATISTICEXPORT: pathHref + '/admin/w/province/statisticExportT',//导出
    PROVINCE_STOCKEXPORT: pathHref + '/admin/w/province/stockExport',//清单内库存统计导出，
    PROV_LIST_FROM_NATION_EXPORT: pathHref + '/admin/w/drugList/provListFromNationExport',

    ALL_LIST_EXPORT:  pathHref + '/admin/w/provinceT/allShortDrugInfoExportT',

    // 国家
    NATION_STATISTIC: pathHref + '/admin/w/nation/statistic',//国家级用户页面加载时，对省级所有医疗机构填报信息进行统计
    NATION_STATISTICSHORTCOUNTDETAIL: pathHref + '/admin/w/nation/statisticShortCountDetail',//短缺药品数量查看
    //  NATION_STATISTICEXPORT: pathHref + '/admin/w/nation/statisticExport',//国家级用户页面加载时，对省级所有医疗机构填报信息进行统计
     NATION_STATISTICEXPORT: pathHref + '/admin/w/nation/statisticExportT',//国家级用户页面加载时，对省级所有医疗机构填报信息进行统计
    NATION_STOCKEXPORT: pathHref + '/admin/w/nation/stockExport',//国家级用户页面加载时，对省级所有医疗机构填报信息进行统计
    NATION_NATIONSTOCK: pathHref + '/admin/w/nation/nationStock',//国家级用户页面加载时，对省级所有医疗机构填报信息进行统计
    COUNTRY_SUBENTRYLIST: pathHref + '/admin/w/country/subentryList',//分享分析
    COUNTRY_GETDETAILS: pathHref + '/admin/w/country/getDetails',//分享分析详情
    NATION_STOCK: pathHref + '/admin/w/nation/stock',//国家查省短缺
    'ADMIN_BASICDEPT_IMPORTPROV': pathHref + '/admin/w/basicDept/importProv',//导入省级
    //机构填报端
    'REPORTFILLDRUG_DRUGFILLLIST': pathHref1 + '/reportFillDrug/drugFillList', //获取医疗机构查询药品填报列表
    'WCIRBUSREPORTFILLDRUG_DRUGFILLLIST': pathHref1 + '/cirBusReportFillDrug/drugFillList', //获取流通企业查询药品填报列表
    'MEDINSTINFO_DEFAULTMODELTYPE': pathHref1 + '/medInstInfo/defaultModelType', //获取默认录入方式
    'MEDINSTINFO_UPDATEDEFAULTMODELTYPE': pathHref1 + '/medInstInfo/updateDefaultModelType', //提交默认录入方式
    'REPORTDRUG_SHORTDRUGINFO': pathHref1 + '/reportDrug/shortDrugInfo', //填报中药品列表信息
    'CIRBUSREPORTDRUG_SHORTDRUGINFO': pathHref1 + '/cirBusReportDrug/shortDrugInfo', //填报中药品列表信息
    'REPORTDRUG_SHORTDRUGINFOJC': pathHref1 + '/reportDrug/jcShortDrugInfo', //填报中药品列表信息
    'REPORTDRUG_FINDDETAILLSTDRUGINFO': pathHref1 + '/reportDrug/findDetailLstDrugInfo', //填报中药品列表信息
    'CIRBUSREPORTDRUG_FINDDETAILLSTDRUGINFO': pathHref1 + '/cirBusReportDrug/findDetailLstDrugInfo', //填报中药品列表信息
    'REPORTDRUG_PRDUTENTPINFOLIST': pathHref1 + '/reportDrug/prdutEntpInfoList', //获取药品名称
    'REPORTDRUG_FORMINFOLIST': pathHref1 + '/reportDrug/formInfoList', //获取剂型
    'REPORTDRUG_SPECINFOLIST': pathHref1 + '/reportDrug/specInfoList', //获取规格
    'REPORTDRUG_DRUGDETAILMSG': pathHref1 + '/reportDrug/drugDetailMsg', //根据药品名称 生产企业 剂型 以及规格 查询 药品的详细信息
    'REPORTDRUG_INSERTDRUGMSG': pathHref1 + '/reportDrug/insertDrugMsg', //添加药品信息 默认 短缺 为否
    'CIRBUSREPORTDRUG_INSERTDRUGMSG': pathHref1 + '/cirBusReportDrug/insertDrugMsg', //添加药品信息 默认 短缺 为否
    'REPORTDRUG_DELETEDRUGMSG': pathHref1 + '/reportDrug/deleteDrugMsg', //删除药品信息
    'CIRBUSREPORTDRUG_DELETEDRUGMSG': pathHref1 + '/cirBusReportDrug/deleteDrugMsg', //删除药品信息
    'REPORTDRUG_UPDATEDRUGKCMSG': pathHref1 + '/reportDrug/updateDrugKcMsg', //保存库存信息
    'REPORTDRUG_UPDATEDRUGMSG': pathHref1 + '/reportDrug/updateDrugMsg', //新增需求
    'REPORTFILLDRUG_DRUGFILLTOREPORT': pathHref1 + '/reportFillDrug/drugFillToReport', //确认上报
    'CIRBUSREPORTFILLDRUG_DRUGFILLTOREPORT': pathHref1 + '/cirBusReportFillDrug/drugFillToReport', //确认上报
    'REPORTFILLDRUG_DRUGZEROFILLTOREPORT': pathHref1 + '/reportFillDrug/drugZeroFillToReport', //确认0上报上报
    'CIRBUSREPORTFILLDRUG_DRUGZEROFILLTOREPORT': pathHref1 + '/cirBusReportFillDrug/drugZeroFillToReport', //确认0上报上报
    'REPORTDRUG_SHORTDRUGDRTAILDATE': pathHref1 + '/reportDrug/shortDrugDrtailDate', //点击 查看 查询 药品短缺信息(重点 非重点 以及 最后查看所有的短缺药品)
    'CIRBUSREPORTDRUG_SHORTDRUGDRTAILDATE': pathHref1 + '/cirBusReportDrug/shortDrugDrtailDate', //点击 查看 查询 药品短缺信息(重点 非重点 以及 最后查看所有的短缺药品)
    'REPORTDRUG_SHORTDRUGINFOINSERT': pathHref1 + '/reportDrug/shortDrugInfoInsert', //填报数据加载

    'REPORTDRUG_CIRCENTPLIST': pathHref1 + '/reportDrug/circEntpList', //获取配送单位
    'REPORTDRUG_DRUGNAMEACLIST': pathHref1 + '/reportDrug/drugNameAcList', //获取药品名称
    'CIRBUSREPORTDRUG_DRUGNAMEACLIST': pathHref1 + '/cirBusReportDrug/drugNameAcList', //获取药品名称
    'REPORTDRUG_UPDATENOPOINTDRUGMSG': pathHref1 + '/reportDrug/updateNoPointDrugMsg', //添加 / 修改 非重点药品的短缺信息
    'CIRBUSREPORTDRUG_UPDATENOPOINTDRUGMSG': pathHref1 + '/cirBusReportDrug/updateNoPointDrugMsg', //添加 / 修改 非重点药品的短缺信息
    'REPORTDRUG_NOPOINTDRUGMSG': pathHref1 + '/reportDrug/noPointDrugMsg', //非重点药品的查询 药品列表信息
    'CIRBUSREPORTDRUG_NOPOINTDRUGMSG': pathHref1 + '/cirBusReportDrug/noPointDrugMsg', //非重点药品的查询 药品列表信息
    'REPORTDRUG_DELETENOPOINTDRUGMSG': pathHref1 + '/reportDrug/deleteNoPointDrugMsg', //删除非重点清单信息
    'CIRBUSREPORTDRUG_DELETENOPOINTDRUGMSG': pathHref1 + '/cirBusReportDrug/deleteNoPointDrugMsg', //删除非重点清单信息
    'REPORTDRUG_NOPOINTDRUGINFO': pathHref1 + '/reportDrug/noPointDrugInfo', //非重点药品信息 通过药品ID 查看药品信息
    'CIRBUSREPORTDRUG_NOPOINTDRUGINFO': pathHref1 + '/cirBusReportDrug/noPointDrugInfo', //非重点药品信息 通过药品ID 查看药品信息
    'REPORTDRUG_ALLDRUGINFO': pathHref1 + '/reportDrug/allDrugInfo', //上报短缺药品处置情况
    'CIRBUSREPORTDRUG_ALLDRUGINFO': pathHref1 + '/cirBusReportDrug/allDrugInfo', //上报短缺药品处置情况
    'ADMIN_REPORTDRUG_REBUTSUGGEST': pathHref1 + '/reportDrug/rebutSuggest',//查看驳回原因
    'CIRBUSREPORTDRUG_REBUTSUGGEST': pathHref1 + '/cirBusReportDrug/rebutSuggest',//查看驳回原因

    // 二期
    // 'SUBURBAN_TODEALSHORTDRUG':pathHref+'/admin/w/suburban/toDealShortDrug', //县级机构处理短缺药品
    'SUBURBAN_TODEALSHORTDRUG': pathHref + '/admin/w/suburban/toDealShortDrugSecond', //县级机构处理短缺药品2.0
    'SUBURBAN_TODEALCIRSHORTDRUGSECOND': pathHref + '/admin/w/suburban/toDealCirShortDrugSecond', //县级机构处理短缺药品2.0
    // 'SUBURBAN_MEDINSTTODEALSHORTDRUG':pathHref+'/admin/w/suburban/medInstToDealShortDrug', //机构处理短缺药品信息
    'SUBURBAN_MEDINSTTODEALSHORTDRUG': pathHref + '/admin/w/suburban/medInstToDealShortDrugSecond', //机构处理短缺药品信息2.0
    'SUBURBAN_MEDINSTTODEALCIRSHORTDRUGSECOND': pathHref + '/admin/w/suburban/medInstToDealCirShortDrugSecond', //机构处理短缺药品信息2.0
    'PROVINCE_REBUTDRUGFROMCOMPDEPT': pathHref + '/admin/w/province/rebutDrugFromCompDept', //直接驳回至医疗机构

    // 三期
    'PROVINCE_ALLSHORTDRUGINFOFROMPRO': pathHref + '/admin/w/province/allShortDrugInfoFromPro', //已上报短缺药品查询
    'PROVINCE_ALLCIRSHORTDRUGINFOFROMPRO': pathHref + '/admin/w/province/allCirShortDrugInfoFromPro', //已上报短缺药品查询
    'PROVINCE_SELECTDRUGDETAIL': pathHref + '/admin/w/province/selectDrugDetail', //查看药品详情
    'PROVINCE_SELECTCIRDRUGDETAIL': pathHref + '/admin/w/province/selectCirDrugDetail', //查看药品详情
    'NOTICEMAGE_SELECTANNOUNCEMENTLIST': pathHref + '/admin/w/noticeMage/selectAnnouncementList', //国家以及省份发布公告的列表
    'NOTICEMAGE_INSERTANNOUNCEMENTINFO': pathHref + '/admin/w/noticeMage/insertAnnouncementInfo', //添加/修改国家以及省份发布公告信息
    'NOTICEMAGE_DELECTANNOUNCEMENTINFO': pathHref + '/admin/w/noticeMage/delectAnnouncementInfo', //删除国家以及省份发布公告信息
    'NOTICEMAGE_FINDANNOUNCEMENTINFO': pathHref + '/admin/w/noticeMage/findAnnouncementInfo', //公告详情
    'NOTICEMAGE_FINDRECEANNOUNCEMENTINFO': pathHref + '/admin/w/noticeMage/findReceAnnouncementInfo', //接受公告列表
    // 'PROVINCE_SHORTDRUGINFOEXPORT': pathHref + '/admin/w/province/shortDrugInfoExport', //occurCount导出
    // 'PROVINCE_SHORTDRUGINFOEXPORT': pathHref + '/admin/w/province/shortDrugInfoExportT', //occurCount导出
    'PROVINCE_SHORTDRUGINFOEXPORT': pathHref + '/admin/w/provinceT/shortDrugInfoExportT', //occurCount导出
    'PROVINCE_SHORTDRUGINFOEXPORTN': pathHref + '/admin/w/province/shortDrugInfoExportN', //occurCount导出字典
    'DRUGLIST_PROVLISTFROMNATION': pathHref + '/admin/w/drugList/provListFromNation', //已上报短缺药品查询省级列表
    'DRUGLIST_PROVLISTDETAILFROMNATION': pathHref + '/admin/w/drugList/provListDetailFromNation', //已上报短缺药品查询省级详情
    'KTBMAGE_KTBMAGELIST': pathHref + '/report/w/ktbMage/ktbMageList', //设置可调拨数量列表查询
    'KTBMAGE_FITKTBZB': pathHref + '/report/w/ktbMage/fitKtbZb', //设置可调拨数量列表
    'SHORTDRUGSTATE_STATECHART': pathHref + '/admin/w/shortDrugState/stateChart', //国家药品短缺状态图
    'IMPORTEXPORTEXCEL_IMPORTDRUGNAME': pathHref + '/admin/w/importExportExcel/importDrugName', //批量导入
    'IMPORTEXPORTEXCEL_EXPORT': pathHref + '/admin/w/importExportExcel/export', //单个药品页面导出
    'COUNTRYSTATIS_DRUGSPECIALSTATISTICS': pathHref + '/admin/w/countryStatis/drugSpecialStatistics', //单药品专项统计
    'COUNTRY_COMCOUNTRYSTA': pathHref + '/admin/w/countryStatis/compRepotDrugCountSta', //机构上报药品短缺药品数量排名统计
    'COUNTRY_COMSTA': pathHref + '/admin/w/countryStatis/compRepotDrugSta', //机构上报药品排名统计
    'COUNTRY_DRUGDISSITUATION': pathHref + '/admin/w/countryStatis/drugDisposalSituation', //处置情况统计
    'IMPORTEXPORTEXCEL_CLICKFILESTATE': pathHref + '/admin/w/importExportExcel/clickFileState', //确定是否打包好
    // 
    'PROVINCET_CLICKFILESTATE': pathHref + '/admin/w/provinceT/clickFileState', //确定是否打包好
    'COUNTRYSTATIS_IMPORTDRUGDATE': pathHref + '/admin/w/countryStatis/importDrugDate', //自定义导入
    'COUNTRYSTATIS_IMPORTDRUGDATET': pathHref + '/admin/w/countryStatis/importDrugDateT', //自定义导入
    'COUNTRYSTATIS_DRUGTYPESTATISTICSDRUGNAME': pathHref + '/admin/w/countryStatis/drugTypeStatisticsDrugName', //查药品
    'COUNTRYSTATIS_DRUGTYPECOUNT': pathHref + '/admin/w/countryStatis/drugTypeStatisticsCount', //药品分类统计
    'COUNTRYSTATIS_DRUGTYPESTATIC': pathHref + '/admin/w/countryStatis/drugTypeStatistics', //药品分类统计详情

    'NOTICEMAGE_SELECTDRUGHAVEDOWNLIST': pathHref + '/admin/w/noticeMage/selectDrugHaveDownList', //国家已解决药品信息列表 
    'NOTICEMAGE_INSERTDRUGHAVEDOWNINFO': pathHref + '/admin/w/noticeMage/insertDrugHaveDownInfo', //添加/修改国家已解决药品信息 
    'NOTICEMAGE_DELECTDRUGHAVEDOWNINFO': pathHref + '/admin/w/noticeMage/delectDrugHaveDownInfo', //国家已解决药品信息的删除 
    'NOTICEMAGE_DRUGHAVEDOWNINFOTOREPORT': pathHref + '/admin/w/noticeMage/drugHaveDownInfoToReport', //国家已解决药品信息（待发布------已发布） 
    'NOTICEMAGE_ANNOUNCEMENTINFOTOCANCELREPORT': pathHref + '/admin/w/noticeMage/announcementInfoToCancelReport', //国家已解决药品信息（取消发布） 
    'NOTICEMAGE_FINDDRUGHAVEDOWNINFO': pathHref + '/admin/w/noticeMage/findDrugHaveDownInfo', //查看国家已解决药品信息详情
    'COUNTRYSTATIS_COMPREPOTDRUGSTAEXPORT': pathHref + '/admin/w/countryStatis/compRepotDrugStaExport', //按上报机构数量排名
    'COUNTRYSTATIS_COMPREPOTDRUGCOUNTSTAEXPORT': pathHref + '/admin/w/countryStatis/compRepotDrugCountStaExport', //按短缺数量排名
    'COUNTRYSTATIS_DRUGDISPOSALSITUATIONEXPORT': pathHref + '/admin/w/countryStatis/drugDisposalSituationExport', //处置情况统计

    // 'GETWRITEDATA':pathHref+'/report/w/hint/getWriteData', //查询机构是否确认信息
    'ADDWRITEDATA': pathHref + '/report/w/hint/addWriteData', //保存机构确认信息
    'COUNTRYSTATIS_UKINFOEXPORT': pathHref + '/admin/w/countryStatis/ukInfoExport', //导出uk信息

    //管理部门处置情况
    'PROVINCE_COMPDEPTSIUINPC': pathHref + '/admin/w/province/compDeptSiuInPC', //代处置列表(部门)
    'PROVINCE_COMPDEPTSIUMEDINSTINPC': pathHref + '/admin/w/province/compDeptSiuMedInstInPC', //代处置列表(机构)
    'PROVINCE_COMPDEPTSIUMEDINSTINPCEXPORT': pathHref + '/admin/w/province/compDeptSiuMedInstInPCExport', //详情(机构)导出
    'PROVINCE_COMPDEPTSIUINPCTODEALNOTALLDRUGBYID': pathHref + '/admin/w/province/compDeptSiuInPCToDealNotAllDrugById', //处置(机构)
    'PROVINCE_COMPDEPTSIUMEDSHORTDRUGINPC': pathHref + '/admin/w/province/compDeptSiuMedShortDrugInPC', //详情(机构)
    'PROVINCE_COMPDEPTSIUMEDSHORTDRUGINPCEXPORT': pathHref + '/admin/w/province/compDeptSiuMedShortDrugInPCExport', //代处置列表(机构)导出
    'PROVINCE_COMPDEPTSIUINPCEXPORT': pathHref + '/admin/w/province/compDeptSiuInPCExport', //代处置列表导出
    'PROVINCE_COMPDEPTSIUINPCTODEAL': pathHref + '/admin/w/province/compDeptSiuInPCToDeal', //代处置(暂时废弃)
    'PROVINCE_COMPDEPTSIUINPCTODEALNOTALLDRUG': pathHref + '/admin/w/province/compDeptSiuInPCToDealNotAllDrug', //代处置
    'PROVINCE_COMPDEPTSIUINPCDETAIL': pathHref + '/admin/w/province/compDeptSiuInPCDetail', //查看详情
    'PROVINCE_COMPDEPTSIUINPCDETAILEXPORT': pathHref + '/admin/w/province/compDeptSiuInPCDetailExport', //查看详情导出

    // 运维端接口
    'SYSTEM_NOTICE_LIST': pathHref + '/admin/w/system/notice/list', //系统通知信息列表
    'SYSTEM_NOTICE_ADD': pathHref + '/admin/w/system/notice/add', //系统通知信息新增
    'SYSTEM_NOTICE_QUERY': pathHref + '/admin/w/system/notice/query', //系统通知信息详情
    'SYSTEM_NOTICE_DEL': pathHref + '/admin/w/system/notice/delete', //系统通知信息删除
    'SYSTEM_NOTICE_UPD': pathHref + '/admin/w/system/notice/update', //系统通知信息编辑
    'SYSTEM_NOTICE_UNREAD': pathHref + '/admin/w/system/notice/unread/query', //系统通知信息详情
    'NOTIC_USER_LIST': pathHref + '/admin/w/system/notice/user/list', //系统通知信息列表
    'SUBURBAN_DRUGALLINFO': pathHref + '/admin/w/suburban/drugAllInfo', //2023-11-9新增 年度上报药品信息大表 导出功能
    'SUBURBAN_EXPORTMAGELOG': pathHref + '/admin/w/suburban/exportMageLog', //2023-11-9新增 文件下载系统日志 导出功能
    'SUBURBAN_UPDATEMEDMOBILELOG': pathHref + '/admin/w/suburban/updateMedMobileLog', //2023-11-9新增 医疗机构手机号修改日志 导出功能
    'SUBURBAN_UPDATECOMPMOBILELOG': pathHref + '/admin/w/suburban/updateCompMobileLog', //2023-11-9新增 主管部门手机号修改日志 导出功能
    'PROVINCET_ALLJCSHORTDRUGINFOEXPORT': pathHref + '/admin/w/provinceT/allJcShortDrugInfoExport', //2023-11-9新增 集采数据导出 导出功能



    //3期 

    //登录重构
    'loginPath': pathHref + str,//登录接口
    // 'loginPath59':pathHref+"/security_mobile/login",//登录接口
    'SECURITY_UNLOGIN_SELECTAREAMEDINFO': pathHref + '/security/unLogin/selectAreaMedInfo', //登录页面省市县联动
    'SECURITY_FINDAREAMEDINSTS': pathHref + '/security/findAreaMedInsts', //根据地区code获取机构列表
    'SECURITY_FINDAREACIRBUS': pathHref + '/security/findAreaCirBus', //根据地区code获取流通企业列表
    'SECURITY_CHECKPHONENUM': pathHref + '/security/checkPhoneNum', //验证用户名是否和手机号相匹配
    'UNLOGIN_CHECKPHONENUMCOMPDEPT': pathHref + '/security/unLogin/checkPhoneNumCompDept', //验证用户名是否和手机号相匹配(管理部门)
    'UNLOGIN_CHECKPHONENUMCY': pathHref + '/security/unLogin/checkPhoneNumCY', //验证用户名是否和手机号相匹配(管理部门/国家运维)
    'REGISTER_MEDREG': pathHref + '/security/register/medReg', //注册
    'SECURITY_MOBILE_VALCODE_CREATE': pathHref + '/security/mobile/valCode/create', //发送验证码
    'SECURITY_ACCOUNT_GETLOGININFO': pathHref + '/security/w/account/getLoginInfo', //获取用户ip等登陆信息
    'SECURITY_BEFOREFIRSTLOGIN': pathHref + '/security/beforeFirstLogin', //验证用户名是否被激活
    'SECURITY_CHECKACTIVECODE': pathHref + '/security/w/checkActiveCode',//首次登陆激活
    'SECURITY_ACCOUNT_GET': pathHref + '/security/w/account/get',//首次登陆激活,获取用户信息
    'SECURITY_ACCOUNT_UPDATEANDACTIVE': pathHref + '/security/w/account/updateAndActivce',//首次激活修改用户信息
    'SECURITY_ACCOUNT_UPDPHONENUM': pathHref + '/security/w/account/updPhoneNum',//修改用户手机号
    'USER_PWD_RESET': pathHref + '/security/i/user/pwd/reset',//设置密码
    // 'USER_ACTIVE_UPDATE':pathHref+'/security/i/user/active/update',//设置密码标识
    'ACCOUNT_UPDACTFLAG': pathHref + '/security/w/account/updActFlag',//设置密码标识
    'SECURITY_ACCOUNT_UPDATE': pathHref + '/security/w/account/update',//修改用户信息
    'SECURITY_USER_VIEWMENU_LIST': pathHref + '/security/w/user/viewMenu/list',//获取菜单
    'SECURITY_LOGOUT': pathHref + '/security/w/logout',//用户注销
    'MOBILE_VALCODE_VALID': pathHref + '/security/mobile/valCode/valid',//修改密码，校验手机号
    'UNLOGIN_PWD_RESET': pathHref + '/security/unLogin/pwd/reset',//修改密码
    'ADMIN_BASICDEPT_EDIT': pathHref + '/admin/w/basicDept/edit',//修改当前用户信息
    'ADMIN_BASICDEPT_ADD': pathHref + '/admin/w/basicDept/add',//管理机构新增
    'ADMIN_ACCOUNT_UPDPWD': pathHref + '/security/w/account/updPwd',//修改密码
    'ADMIN_BASICDEPT_PWDRESET': pathHref + '/admin/w/basicDept/pwdReset',//重置密码


    // 导出文件信息
    'ADMIN_W_EXPORTFILEINFOMAGE_INSERTEXPORTFILEINFO': pathHref + '/admin/w/exportFileInfoMage/insertExportFileInfo',//导出文件                          
    // 黑名单  
    'ADMIN_BLACKLISTMAGE_FINDBLACKLIST': pathHref + '/admin/w/blackListMage/findBlackList',//黑名单--列表
    'ADMIN_BLACKLISTMAGE_INSERTBLACKLISTINFO': pathHref + '/admin/w/blackListMage/insertBlackListInfo',//黑名单--添加
    'ADMIN_BLACKLISTMAGE_UPDATEBLACKLISTINFO': pathHref + '/admin/w/blackListMage/updateBlackListInfo',//黑名单--删除      

    // 价格监测
    'ADMIN_PROVINCE_ALLSHORTDRUGPRICEFROMPRO': pathHref + '/admin/w/province/allShortDrugPriceFromPro',//列表
    'ADMIN_SUBURBAN_MEDINSTTODEALSHORTDRUGPRICE': pathHref + '/admin/w/suburban/medInstToDealShortDrugPrice',//上报
    'ADMIN_SUBURBAN_SUBURBANCOLLECTSITUATION': pathHref + '/admin/w/suburban/suburbanCollectSituation',//已短缺药品信息确认总览
    'SUBURBAN_SUBURBANCIRCOLLECTSITUATION': pathHref + '/admin/w/suburban/suburbanCirCollectSituation',//已短缺药品信息确认总览
  
    //查看表单
    'MEDICALCARE_EXPORMEDICALCARE': pathHref1 + '/medicalCare/exportMedicalCare', //黑龙江表单查询
    'MEDICALCARE_VIEWSHOTDRUGFORM': pathHref1 + '/medicalCare/viewShotDrugForm', //黑龙江医疗机构查看根据药品
    'W_REPORTDRUG_UPDATENOPOINTDRUGMSG': pathHref1 + '/reportDrug/updateNoPointDrugMsg', //黑龙江提交填报
    'CIRBUSREPORTDRUG_UPDATENOPOINTDRUGMSG': pathHref1 + '/cirBusReportDrug/updateNoPointDrugMsg', //黑龙江提交填报
    'MEDICALCARE_VIEWSHOTDRUGLIST': pathHref1 + '/medicalCare/viewShotDrugList', //黑龙江医疗机构查看获取药品列表
    'MEDICALCARE_EXPORTMEDICALCARE': pathHref1 + '/medicalCare/exportMedicalCare',//黑龙江医疗机构导出压缩包
    'REPORTFILLDRUG_DRUGTOREPORT': pathHref1 + '/reportFillDrug/drugToReport',//但药品上报


    'GETMEDICAL_INSTITUTION_DETAIL': pathHref + '/admin/w/competentDepartment/getMedicalInstitutionDetail',//黑龙江医疗机构表单详情
    'VIEWDRUGFORM': pathHref + '/admin/w/competentDepartment/viewDrugForm',//黑龙江获取药品处置表单详情
    'EXPORTMEDICALCARE': pathHref + '/admin/w/competentDepartment/exportMedicalCare',//黑龙江导出药品处置表单
    // 'UNLOGIN_SELECTAREAMEDINFO': pathHref + '/unLogin/selectAreaMedInfo'//省市县


    //运维新增机构撤销管理接口
    'GETREPORTS': pathHref + '/admin/w/competentDepartment/getReports',//机构填报管理列表
    'BACKREPORTS': pathHref + '/admin/w/competentDepartment/backReports',//撤销操作
    'FINDPAGELIST': pathHref + '/admin/w/OrgRevokeList/findPageList',//机构已撤销列表
    'W_BASICMEDICAL_MEDLOGINDATEEXPORT': pathHref + '/admin/w/basicMedical/medLoginDateExport',//运维端-医疗机构月登录时间导出
    'W_SYSOPERATIONLOG_INSETOPERATIONLOG': pathHref + '/admin/w/sysOperationLog/insetOperationLog',//运维端国家端-增加修改手机号日志
    
    //流通企业基本信息管理接口
    'W_BASICCIRBUS_LIST': pathHref + '/admin/w/basicCirBus/list',//流通企业列表
    'W_BASICCIRBUS_GET': pathHref + '/admin/w/basicCirBus/get',//获取流通企业信息
    'W_BASICCIRBUS_DELETE': pathHref + '/admin/w/basicCirBus/delete',//删除流通企业
    'W_BASICCIRBUS_ADD': pathHref + '/admin/w/basicCirBus/add',//流通企业新增
    'W_BASICCIRBUS_EDIT': pathHref + '/admin/w/basicCirBus/edit',//流通企业修改
    'W_BASICCIRBUS_EXPORT': pathHref + '/admin/w/basicCirBus/export',//导出1--打包
    'SECURITY_UNLOGIN_USERLOCKCHECK': pathHref + '/security/unLogin/userLockCheck',//判断用户是否被锁定
    'SECURITY_UNLOGIN_LOGINERROR': pathHref + '/security/unLogin/loginError',//用户输入密码错误

    //2022-10 新加的药企响应系统接口
    SECURITY_FINDAREAMEDCOMP: pathHref + '/security/findAreaMedComp',//登录界面查询药企单位列表
    MEDCOMP_ALLSHORTDRUGINFOFROMMEDCOMP: pathHref + '/admin/w/medComp/allShortDrugInfoFromMedComp',//已上报短缺药品查询(药企单位)
    MEDCOMP_RESPMEDINFO: pathHref + '/admin/w/medComp/respMedInfo',//药企单位提交响应信息
    MEDCOMP_FINDRESPMEDINFOLIST: pathHref + '/admin/w/medComp/findRespMedInfoList',//药企单位查看已响应药品信息
    MEDCOMPREPORTFILLDRUG_DRUGFILLLIST: pathHref + '/report/w/medCompReportFillDrug/drugFillList',//上报短缺药品主列表【清单列表】
    PRODREPORTDRUG_UPDATENOPOINTDRUGMSG: pathHref + '/report/w/prodReportDrug/updateNoPointDrugMsg',//添加/修改药品
    PRODREPORTDRUG_DELETEDRUGMSG: pathHref + '/report/w/prodReportDrug/deleteDrugMsg',//单个药品信息删除
    PRODREPORTDRUG_DELETENOPOINTDRUGMSG: pathHref + '/report/w/prodReportDrug/deleteNoPointDrugMsg',//删除清单
    MEDCOMPREPORTFILLDRUG_DRUGFILLTOREPORT: pathHref + '/report/w/medCompReportFillDrug/drugFillToReport',//清单上报
    PRODREPORTDRUG_PRODSHORTDRUGDRTAILDATE: pathHref + '/report/w/prodReportDrug/prodShortDrugDrtailDate',//药品列表信息
    REPORTDRUG_DRUGRESPONDINFO: pathHref + '/report/w/reportDrug/drugRespondInfo',//短缺药品药企响应情况 【医疗机构填报端】
    REPORTDRUG_FINDRESPONDMSGLIST: pathHref + '/report/w/reportDrug/findRespondMsgList',//短缺药品药企响应情况,查看响应信息 【医疗机构填报端】
    REPORTDRUG_TOREADRESPONDMSG: pathHref + '/report/w/reportDrug/toReadRespondMsg',//短缺药品药企响应情况,更新响应状态 【医疗机构填报端】
    SUBURBAN_FINDALLRESPONDMSGLIST: pathHref + '/admin/w/suburban/findAllRespondMsgList',//短缺药品药企响应情况, 【主管部门管理端】
    PROVINCE_FINDCOMPDRUGS: pathHref + '/admin/w/province/findCompDrugs',//短缺药品药企上报情况, 【主管部门管理端-省级】
    PROVINCE_COMPDRUGSEXPORT: pathHref + '/admin/w/province/compDrugsExport',//短缺药品药企上报情况-导出, 【主管部门管理端-省级】


    //2022-12-14新加的填报端 新冠药品
    NCPDRUG_DRUGINFO: pathHref + '/report/w/ncpDrug/drugInfo',//获取需要填报的药品列表
    NCPDRUG_DRUGREPORT: pathHref + '/report/w/ncpDrug/drugReport',//提交所填写的药品信息
    PROVINCE_NCPDRUGSEXPORT: pathHref + '/admin/w/province/ncpDrugsExport',//导出所有的上报药品信息
    PROVINCE_NCPDRUGSREPORTEXPORT: pathHref + '/admin/w/province/ncpDrugsReportExport',//当日上报情况统计
    //UNLOGIN_ONLYFSSHOW: pathHref + '/report/unLogin/onlyFsShow',//【2024-1-31废弃接口】查询新冠用药菜单是否展示   true 展示   false  不展示
    MEDINSTINFO_ONLYFSSHOW: pathHref + '/report/w/medInstInfo/onlyFsShow',//查询新冠用药菜单是否展示   true 展示   false  不展示

    //2023-8 新增的视频列表
    TENCENTVOD_PAGE: pathHref + '/report/w/tencentVod/page',//视频列表

    //2023-12-6新加的省级药企单位响应 陕西省
    NCPDRUG_DRUGINFOPROD: pathHref + '/report/w/ncpDrug/drugInfoProd',//获取需要填报的药品列表
    NCPDRUG_DRUGREPORTPROD: pathHref + '/report/w/ncpDrug/drugReportProd',//提交所填写的药品信息

    //2024-1-24 新增满意度调研
    USERACSI_USERACSIIFSHOW: pathHref + '/report/w/userAcsi/userAcsiIfShow',//是否展示满意度调研
    USERACSI_USERACSIREPORT: pathHref + '/report/w/userAcsi/userAcsiReport',//满意度调研提交

    //2024-11-25 新增
    UNLOGIN_CIRAREAS: pathHref + '/security/unLogin/cirAreas',//流通企业登录首页接口【配送企业填报端，企业省份接口】
    PROVINCET_IFHAVECIRINFO: pathHref + '/admin/w/provinceT/ifHaveCirInfo',//省级部门配置 【配送企业填报端】省份数据

    //省级药企单位响应子系统
    UNLOGIN_PRODINSTAREAS: pathHref + '/security/unLogin/prodInstAreas',//获取药企单位区域



    



    


  };


  // 设置给全局
  window.Action = Action;
  /*window.basePath = basePath;*/
  window.hasSubDomain = hasSubDomain;
  window.isRootDomain = isRootDomain;
  window.pathHref1 = pathHref1;
})(window, window.jQuery);



//////////////////
// WEBPACK FOOTER
// ./static/js/OstPaths.js
// module id = DsXP
// module chunks = 134